"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bannerActionDowloadApp = exports.bannerAction = exports.bannerActionPixel = exports.bannerImpression = exports.bannerImpressionPixel = void 0;
var axios_1 = require("axios");
var commonProperties_1 = require("./lib/commonProperties");
var config_1 = require("./config");
var _1 = require(".");
var ViewportMonitor_1 = require("./lib/ViewportMonitor");
var ENDPOINT_IMPRESSION = function (baseUrl) { return baseUrl + "/Banner/Impression"; };
var ENDPOINT_ACTION = function (baseUrl) { return baseUrl + "/Banner/Action"; };
var ENDPOINT_ACTION_DOWNLOAD_APP = function (baseUrl) {
    return baseUrl + "/Banner/Action/DownloadApp";
};
var ImpressionBannerStats = /** @class */ (function () {
    function ImpressionBannerStats(baseUrl, getCookie, setCookie) {
        var _this = this;
        this._pushImpression = function (item, container) {
            var view = container.dataset.view;
            var _a = item.dataset, bannerid = _a.bannerid, bannertype = _a.bannertype, banneridentifier = _a.banneridentifier;
            exports.bannerImpression(_this.BaseUrl, _this.$getCookie, _this.$setCookie, parseInt(bannerid), bannertype, banneridentifier, undefined, undefined, view);
        };
        this.BaseUrl = baseUrl;
        this.$getCookie = getCookie;
        this.$setCookie = setCookie;
        this.Views = {};
        this.ViewportMonitor = new ViewportMonitor_1.default({
            containerClass: "js-print-banner-container",
            itemClass: "js-print-banner-item",
            onNewContainer: function () { },
            onNewItem: this._pushImpression,
        });
    }
    return ImpressionBannerStats;
}());
exports.default = ImpressionBannerStats;
exports.bannerImpressionPixel = function (baseUrl, BannerId, BannerType, BannerIdentifier, Latitude, Longitude, View, CatalogId, Position) {
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, Provider = _a.Provider, SearchType = _a.SearchType, Integration = _a.Integration;
    var entity = {
        BannerId: BannerId,
        PageType: "AMP_" + PageType,
        SearchType: SearchType,
        SearchCity: encodeURIComponent(SearchCity),
        SearchWord: encodeURIComponent(SearchWord),
        Provider: Provider,
        Origin: Origin,
        Integration: Integration,
        Platform: Platform || _1.Device.Mobile,
        BannerType: BannerType,
        BannerIdentifier: BannerIdentifier,
        Latitude: Latitude,
        Longitude: Longitude,
        View: View,
        CatalogId: CatalogId,
        Position: Position,
        UserToken: commonProperties_1.getUserTokenAMP(),
        ClientTimeStamp: commonProperties_1.getFormattedClientTimeStamp(),
        TimeZoneOffset: commonProperties_1.getTimezoneOffset(),
    };
    return ENDPOINT_IMPRESSION(baseUrl) + "/Pixel?entity=" + JSON.stringify(entity);
};
exports.bannerImpression = function (baseUrl, getCookie, setCookie, BannerId, BannerType, BannerIdentifier, Latitude, Longitude, View, CatalogId, Position) {
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, Platform = _a.Platform, Origin = _a.Origin, Integration = _a.Integration, OpeningHash = _a.OpeningHash, PageType = _a.PageType, SearchType = _a.SearchType;
    var params = {
        BannerId: BannerId,
        PageType: PageType,
        SearchType: SearchType,
        SearchCity: SearchCity,
        SearchWord: SearchWord,
        Platform: Platform,
        Origin: Origin,
        Provider: Integration,
        Integration: Integration,
        BannerType: BannerType,
        BannerIdentifier: BannerIdentifier,
        Latitude: Latitude,
        Longitude: Longitude,
        View: View,
        CatalogId: CatalogId,
        Position: Position,
        OpeningHash: OpeningHash,
    };
    axios_1.default.post(ENDPOINT_IMPRESSION(baseUrl), __assign(__assign({}, params), commonProperties_1.default(getCookie, setCookie)));
};
exports.bannerActionPixel = function (baseUrl, BannerId, BannerType, BannerIdentifier, Latitude, Longitude, View, CatalogId, Position) {
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, SearchType = _a.SearchType, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, Integration = _a.Integration, OpeningHash = _a.OpeningHash;
    var entity = {
        BannerId: BannerId,
        SearchCity: SearchCity,
        SearchWord: SearchWord,
        Platform: Platform,
        Origin: Origin,
        Provider: Integration,
        Integration: Integration,
        BannerType: BannerType,
        BannerIdentifier: BannerIdentifier,
        Latitude: Latitude,
        Longitude: Longitude,
        View: View,
        PageType: PageType,
        SearchType: SearchType,
        CatalogId: CatalogId,
        Position: Position,
        OpeningHash: OpeningHash,
        UserToken: commonProperties_1.getUserTokenAMP(),
        ClientTimeStamp: commonProperties_1.getFormattedClientTimeStamp(),
        TimeZoneOffset: commonProperties_1.getTimezoneOffset(),
    };
    return ENDPOINT_ACTION(baseUrl) + "/Pixel?entity=" + JSON.stringify(entity);
};
exports.bannerAction = function (baseUrl, getCookie, setCookie, BannerId, BannerType, BannerIdentifier, Latitude, Longitude, View, CatalogId, Position) {
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, SearchType = _a.SearchType, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, Integration = _a.Integration, OpeningHash = _a.OpeningHash;
    var params = {
        BannerId: BannerId,
        SearchCity: SearchCity,
        SearchWord: SearchWord,
        Platform: Platform,
        Origin: Origin,
        Provider: Integration,
        Integration: Integration,
        BannerType: BannerType,
        BannerIdentifier: BannerIdentifier,
        Latitude: Latitude,
        Longitude: Longitude,
        View: View,
        PageType: PageType,
        SearchType: SearchType,
        CatalogId: CatalogId,
        Position: Position,
        OpeningHash: OpeningHash,
    };
    return axios_1.default.post(ENDPOINT_ACTION(baseUrl), __assign(__assign({}, params), commonProperties_1.default(getCookie, setCookie)));
};
exports.bannerActionDowloadApp = function (baseUrl, getCookie, setCookie, BannerId, BannerType, BannerIdentifier, Latitude, Longitude, View, CatalogId, Position) {
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, SearchType = _a.SearchType, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, Integration = _a.Integration, OpeningHash = _a.OpeningHash;
    var entity = __assign({ BannerId: BannerId,
        SearchCity: SearchCity,
        SearchWord: SearchWord,
        Platform: Platform,
        Origin: Origin, Provider: Integration, Integration: Integration,
        BannerType: BannerType,
        BannerIdentifier: BannerIdentifier,
        Latitude: Latitude,
        Longitude: Longitude,
        View: View,
        PageType: PageType,
        SearchType: SearchType,
        CatalogId: CatalogId,
        Position: Position,
        OpeningHash: OpeningHash }, commonProperties_1.default(getCookie, setCookie));
    return ENDPOINT_ACTION_DOWNLOAD_APP(baseUrl) + "?entity=" + JSON.stringify(entity);
};
//# sourceMappingURL=banner.js.map